module.exports = __webpack_public_path__ + "static/media/bytt-no-18.145b444b.mp3";